var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#0B966B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.5 9.5l3-2 2.5 2 2.5-2 3 2M3.5 7.5v-6M8.5 7.5v-6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0B966B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.5.5v9l-5.5 6-5.5-6v-9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B966B",
    fillRule: "nonzero",
    d: "M4 13h4l-2 2.5z"
  }))));
}
export default SvgIconPencil;